





















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
@Component({})
export default class orderGiftList extends Vue {
  @Prop() gift_list
  coupons: any = []
  @Watch('gift_list')
  async created() {}
  clickReturn() {
    this.$emit('clickReturn')
  }
}
